import {createContext, ReactNode } from "react";
import {useLocalStorage} from "../../hooks/useLocalStorage";
import {authConstants} from "../../constants/auth.constants";

export interface iAuthContext {
  user: object | null;
  setUser: (newVal: any) => void;
}


export const AuthContext = createContext<iAuthContext>({
  user: null,
  setUser: () => {}
});

export function AuthProvider(props: { children: ReactNode; }) {
  const [user, setUser] = useLocalStorage(authConstants.LOCAL_STORAGE_KEY, null);
  return <>
    <AuthContext.Provider value={{user, setUser}}>
      {props.children}
    </AuthContext.Provider>
  </>
}
